import RequestModel from "@/models/RequestModel";
import RequestedJob from "@/models/requests/base/requested-job";
import { IJobRequestState } from "./interfaces/job-request-state";

export default class JobRequestState implements IJobRequestState {
    public requestedJob: RequestedJob | null = null
    public jobRequestDocuments: RequestModel[] = []
}
